var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg191075Ff6Fa48B9C2E5F1Bdcdb3Ea9D6(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "420px",
    height: "420px",
    viewBox: "0 0 420 420",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Leiri-tarppo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Leiri-tarppo",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M210,419 C94.5722857,419 1,325.427714 1,210 C1,94.5722857 94.5722857,1 210,1 C325.427714,1 419,94.5722857 419,210 C419,325.427714 325.427714,419 210,419 Z",
    id: "Fill-17",
    fill: "#5E0F75"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Tent",
    fill: "#FFFFFF",
    points: "255.66068 121.490338 231.058553 102 210.000454 128.582026 188.942355 102 164.340228 121.490338 189.979056 153.855012 81.3333549 291 121.375243 291 210.000454 179.127999 298.625665 291 338.666645 291 230.020944 153.855012"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg191075Ff6Fa48B9C2E5F1Bdcdb3Ea9D6);
export default __webpack_public_path__ + "static/media/191075ff6fa48b9c2e5f1bdcdb3ea9d6.1e43c090913211a3e6181628a9327633.svg";
export { ForwardRef as ReactComponent };